import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import {
  faBuilding,
  faUser,
  faBoxes,
  faPeopleCarry,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";

//Components
import MainCard from "../../components/MainCard/MainCard";
import Stepper from "../../components/Stepper/Stepper";
import Estabelecimento from "./components/Estabelecimento";
import Responsaveis from "./components/Responsaveis";
import Residuos from "./components/Residuos";
import Coleta from "./components/Coleta";
import Loading from "../../components/Loading/Loading";

//Api
import pgrss_api from "../../api/pgrss_api";

//Helpers
import { showMessage } from "../../helpers/message";
import { validarCampos, objCampo } from "../../helpers/ValidadorDeCampos";
import FichaPgrss from "./FichaPgrss";

//Estado inicial do pgrss
function initialStatePGRSS() {
  return {
    cgrss: "",
    funcionamento: "",
    qtdFuncionarios: "",
    condicaoFuncionamento: "",
    horarioFuncionamento: "",
    diasFuncionamento: "",
    empresaPCMSO: "",
    enderecoEmpresaPCMSO: "",
    empresaControlePragas: "",
    empresaControlePragasAlvara: "",
    rotinasBiosseguranca: "",
    alvaraSanitario: "",
    alvaraSanitarioNumero: "",
    alvaraSanitarioValidade: "",
    licencaAmbiental: "",
    licencaAmbientalNumero: "",
    licencaAmbientalValidade: "",
    respEstabelecimentoNome: "",
    respEstabelecimentoEmail: "",
    respEstabelecimentoCep: "",
    respEstabelecimentoLogradouro: "",
    respEstabelecimentoBairro: "",
    respEstabelecimentoCidade: "",
    respEstabelecimentoTelefone: "",
    elaboracaoPGRSSNome: "",
    elaboracaoPGRSSEmail: "",
    elaboracaoPGRSSCep: "",
    elaboracaoPGRSSLogradouro: "",
    elaboracaoPGRSSBairro: "",
    elaboracaoPGRSSCidade: "",
    elaboracaoPGRSSTelefone: "",
    elaboracaoPGRSSIdentProfissional: "",
    elaboracaoPGRSSATR: "",
    elaboracaoPGRSSConselhoClasse: "",
    gerenciamentoPGRSSNome: "",
    gerenciamentoPGRSSEmail: "",
    gerenciamentoPGRSSCep: "",
    gerenciamentoPGRSSLogradouro: "",
    gerenciamentoPGRSSBairro: "",
    gerenciamentoPGRSSCidade: "",
    gerenciamentoPGRSSTelefone: "",
    gerenciamentoPGRSSIdentProfissional: "",
    gerenciamentoPGRSSATR: "",
    gerenciamentoPGRSSConselhoClasse: "",
    totalResiduosMes: "",
    recipienteGrupopA: "",
    recipienteGrupopB: "",
    recipienteGrupopC: "",
    recipienteGrupopD: "",
    recipienteGrupopE: "",
    frequenciaGrupoA: "",
    frequenciaGrupoB: "",
    frequenciaGrupoC: "",
    frequenciaGrupoD: "",
    frequenciaGrupoE: "",
    horarioGrupoA: "",
    horarioGrupoB: "",
    horarioGrupoC: "",
    horarioGrupoD: "",
    horarioGrupoE: "",
    areaInternaAcondicionamentoResiduos: "",
    areaExternaAcondicionamentoResiduos: "",
    horarioFrequenciaGrupoA: "",
    horarioFrequenciaGrupoB: "",
    horarioFrequenciaGrupoC: "",
    horarioFrequenciaGrupoD: "",
    horarioFrequenciaGrupoE: "",
  };
}

export default function Pgrss() {
  //Estado de controle de loading na tela
  const [loading, setLoading] = useState(false);

  //Estado de controle da ficha
  const [ficha, setFicha] = useState(null);

  //Estado de controle dos erros nos campos obrigatorios
  const [errors, setErrors] = useState({});

  //Campos obrigatorios do segundo passo do pgrss
  const camposResponsaveis = [
    objCampo({ name: "respEstabelecimentoNome", required: true }),
    objCampo({ name: "respEstabelecimentoEmail", required: true, email: true }),
    objCampo({ name: "respEstabelecimentoCep", required: true }),
    objCampo({ name: "respEstabelecimentoLogradouro", required: true }),
    objCampo({ name: "respEstabelecimentoBairro", required: true }),
    objCampo({ name: "respEstabelecimentoCidade", required: true }),
    objCampo({ name: "respEstabelecimentoTelefone", required: true }),
    objCampo({ name: "elaboracaoPGRSSNome", required: true }),
    objCampo({ name: "elaboracaoPGRSSEmail", required: true, email: true }),
    objCampo({ name: "elaboracaoPGRSSCep", required: true }),
    objCampo({ name: "elaboracaoPGRSSLogradouro", required: true }),
    objCampo({ name: "elaboracaoPGRSSBairro", required: true }),
    objCampo({ name: "elaboracaoPGRSSCidade", required: true }),
    objCampo({ name: "elaboracaoPGRSSTelefone", required: true }),
    objCampo({ name: "elaboracaoPGRSSIdentProfissional", required: true }),
    objCampo({ name: "elaboracaoPGRSSART", required: true }),
    objCampo({ name: "elaboracaoPGRSSConselhoClasse", required: true }),
    objCampo({ name: "gerenciamentoPGRSSNome", required: true }),
    objCampo({ name: "gerenciamentoPGRSSEmail", required: true, email: true }),
    objCampo({ name: "gerenciamentoPGRSSCep", required: true }),
    objCampo({ name: "gerenciamentoPGRSSLogradouro", required: true }),
    objCampo({ name: "gerenciamentoPGRSSBairro", required: true }),
    objCampo({ name: "gerenciamentoPGRSSCidade", required: true }),
    objCampo({ name: "gerenciamentoPGRSSTelefone", required: true }),
    objCampo({ name: "gerenciamentoPGRSSIdentProfissional", required: true }),
    objCampo({ name: "gerenciamentoPGRSSART", required: true }),
    objCampo({ name: "gerenciamentoPGRSSConselhoClasse", required: true }),
  ];
  //Campos obrigatorios do passo de residuos
  const camposResiduos = [
    objCampo({ name: "totalResiduosMes", required: true, number: true }),
  ];
  //Estado de controle do passo ativo no pgrss
  const [activeStep, setActiveStep] = useState(1);

  //Estado que guarda todos os campos do pgrss
  const [pgrss, setPgrss] = useState(initialStatePGRSS());
  const loadPGRSS = () => {
    setLoading(true);
    pgrss_api
      .GetItem()
      .then((response) => {
        if (response.data.totalResiduosMes) {
          response.data.totalResiduosMes = response.data.totalResiduosMes
            .toString()
            .replace(".", ",");
        }
        Object.keys(response.data).map((value) => {
          if (!response.data[value]) {
            response.data[value] = "";
          }
        });
        if (response.data.id === "") {
          response.data.id = 0;
        } else {
          setFicha(true);
        }
        if (response.data.diasFuncionamento.length > 0) {
          response.data.diasFuncionamento = response.data.diasFuncionamento
            .split("|")
            .map((value) => {
              return { label: value, value: value };
            });
        } else {
          response.data.diasFuncionamento = [];
        }
        setPgrss(response.data);
      })
      .catch((e) => showMessage("Aviso", e.message, "error", null))
      .finally((f) => setLoading(false));
  };

  //Função que valida os campos dos responsaveis
  const validateResponsaveis = () => {
    const _errors = validarCampos(pgrss, camposResponsaveis);
    setErrors(_errors[0]);
    return _errors[1];
  };

  //Função que valida os residuos
  const validateResiduos = () => {
    const _errors = validarCampos(pgrss, camposResiduos);
    setErrors(_errors[0]);
    return _errors[1];
  };

  //Função que valida os campos do passo Coleta
  const validateColeta = () => {
    if (pgrss.transportadores.length == 0) {
      showMessage(
        "Aviso",
        "Informe ao menos um transportador para gerar o pgrss!",
        "info",
        null
      );
      return ["Quantidade de transportadores insuficiente"];
    }
    return [];
  };

  //Passos do pgrss do gerador validateStep: validateResponsaveis
  const steps = [
    { text: "Estabelecimento", icon: faBuilding },
    { text: "Responsáveis", icon: faUser, validateStep: validateResponsaveis },
    { text: "Resíduos", icon: faBoxes, validateStep: validateResiduos },
    { text: "Coleta", icon: faPeopleCarry, validateStep: validateColeta },
    { text: "Finalizar", icon: faCheck },
  ];

  //Função que pega os dados do passo de acordo com o passo ativo
  function getSteps() {
    switch (activeStep) {
      case 1: {
        return (
          <Estabelecimento
            estabelecimento={pgrss}
            setEstabelecimento={setPgrss}
          />
        );
      }
      case 2: {
        return (
          <Responsaveis
            pgrss={pgrss}
            setPgrss={setPgrss}
            errors={errors}
            setErrors={setErrors}
            campos={camposResponsaveis}
          />
        );
      }
      case 3: {
        return (
          <Residuos
            residuos={pgrss}
            setResiduos={setPgrss}
            errors={errors}
            setErrors={setErrors}
            campos={camposResiduos}
          />
        );
      }
      case 4: {
        return <Coleta coleta={pgrss} setColeta={setPgrss} />;
      }
      case 5: {
        return (
          <FichaPgrss
            editar={(activeStep) => setActiveStep(activeStep)}
            pgrssForm={pgrss}
          />
        );
      }
    }
  }

  //Função que salva o pgrss
  function onSubmitPGRSS() {
    const _pgrss = { ...pgrss };
    _pgrss.totalResiduosMes = _pgrss.totalResiduosMes.replace(",", ".");
    const diasFuncionamento = [..._pgrss.diasFuncionamento];
    _pgrss.diasFuncionamento = _pgrss.diasFuncionamento
      .map((value) => value.value)
      .toString()
      .replaceAll(",", "|");
    _pgrss.qtdFuncionarios = _pgrss.qtdFuncionarios
      ? _pgrss.qtdFuncionarios
      : "0";
    setLoading(true);
    if (!pgrss.id) {
      pgrss_api
        .Insert(_pgrss)
        .then((response) => {
          response.data.totalResiduosMes = response.data.totalResiduosMes
            .toString()
            .replace(".", ",");
          response.data.diasFuncionamento = diasFuncionamento;
          setPgrss(response.data);
          showMessage("Sucesso", "Pgrss salvo com sucesso!", "success", () => {
            setActiveStep(1);
            setFicha(true);
          });
        })
        .catch((e) => showMessage("Aviso", e.message, "error", null))
        .finally((f) => setLoading(false));
    } else {
      pgrss_api
        .Update(_pgrss)
        .then((response) => {
          response.data.totalResiduosMes = response.data.totalResiduosMes
            .toString()
            .replace(".", ",");
          response.data.diasFuncionamento = diasFuncionamento;
          setPgrss(response.data);
          showMessage("Sucesso", "Pgrss salvo com sucesso!", "success", () => {
            setActiveStep(1);
            setFicha(true);
          });
        })
        .catch((e) => showMessage("Aviso", e.message, "error", null))
        .finally((f) => setLoading(false));
    }
  }

  //Carrega os dados do PGRSS assim que a tela é inicializada
  useEffect(() => {
    loadPGRSS();
  }, []);

  if (ficha && pgrss.id) {
    return <FichaPgrss pgrssForm={pgrss} btnEditar={() => setFicha(null)} />;
  }

  return (
    <MainCard btnVoltar={pgrss.id ? () => setFicha(true) : null}>
      {loading && <Loading />}
      <Row className="mb-4">
        <Col md="12" lg="12">
          <span className="text-danger fw-bold">*</span> Campos obrigatórios
        </Col>
      </Row>
      <Stepper
        steps={steps}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        onSubmit={onSubmitPGRSS}
      >
        {getSteps()}
      </Stepper>
    </MainCard>
  );
}
